import { useCallback, useState } from 'react';
import dynamic from 'next/dynamic';

import { DISTRIBUTOR_NAME } from '@autopass-web/domain';

import { MapCta2AppButton } from '../../../components/map-cta-2-app-button';
import { BottomNavBar } from '../../../components/toyota-lexus/bottom-nav-bar';
import { LoginHintModal } from '../../../components/toyota-lexus/login-hint-modal';
import Primary from '../../../layout/primary';
import { CURRENT_DISTRIBUTOR } from '../../../new-distributor-config';
import storage from '../../../service/storage';

import type {
  BasePoiCharacteristics,
  FilterOptions,
  PinType,
} from '@autopass-web/feature-maps';
import type { Poi } from '@autopass-web/types';

const BOTTOM_NAV_BAR_HEIGHT = 60;

const FeatureMaps = dynamic(() => import('@autopass-web/feature-maps'), {
  ssr: false,
});

export const HotaiPage = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const hasAuth = storage.getAuth();

  const handleMapCtaButtonClick = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  return (
    <>
      <Primary>
        <FeatureMaps
          basePath="/maps"
          isNextModule
          events={{
            distributorName: DISTRIBUTOR_NAME[CURRENT_DISTRIBUTOR],
          }}
          parsePinType={parsePinType}
          poiCardTutorialConfig={{ isExternallyNavigable: false }}
          basePoiCharacteristics={MAP_BASE_POI_CHARACTERISTICS}
          customFilterOptions={MAP_CUSTOM_FILTER_OPTIONS}
          bottomAdditionalOffset={BOTTOM_NAV_BAR_HEIGHT}
          customText={{
            parkingAutopassFilterLabel: '和泰Pay x 快速通',
          }}
          externalWidgets={{
            ctaButton: !!hasAuth ? null : (
              <MapCta2AppButton
                distributor={CURRENT_DISTRIBUTOR}
                onClick={handleMapCtaButtonClick}
              />
            ),
          }}
        />
        <BottomNavBar />
      </Primary>
      <LoginHintModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

const MAP_BASE_POI_CHARACTERISTICS = {
  parkinglot: {
    cooperationStates: ['not_in_cooperated', 'in_cooperated', 'coming_soon'],
  },
} as BasePoiCharacteristics;

const MAP_CUSTOM_FILTER_OPTIONS = {
  parkinglot: {
    parkingServices: ['autopass'],
    vehicleTypes: ['car', 'moto'],
    payTaipeiCategories: ['pay_taipei_no_card_entry_exit'],
  },
} as FilterOptions;

function parsePinType(poi: Poi): PinType {
  switch (poi.type) {
    case 'Parkinglot': {
      const { cooperation_state } = poi;
      if (cooperation_state === 'in_cooperated') return 'parkinglot-autopass';

      return 'parkinglot';
    }
    default:
      throw new Error('parsePinType: Invalid poi type');
  }
}
